export const MS_IN_ONE_MINUTE: number = 60000; 